import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    template: `
        <div class="content-panel">
            <div class="content-container">
                <ng-transclude></ng-transclude>
            </div>
        </div>
        <style>
            learn-modal-materials-wrapper-content-panel {
                display: contents;
            }
        </style>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/learnModal/materialsWrapper/content/panel/index.js